import axios from "axios";

const getDefaultState = () => {
  return {
    relatorios: [],
    tipoSelecionado: 1,
    vendedorSelecionado: 0,
  };
};

const relatoriosStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setRelatorios(state, relats) {
      state.relatorios = relats;
    },
    setTipoSelecionado(state, value) {
      state.tipoSelecionado = value;
    },
    setVendedor(state, value) {
      state.vendedorSelecionado = value;
    },
  },
  actions: {
    async getRelatorios(context) {
      context.commit("setRelatorios", []);
      await axios
        .get("/nutricao-animal/relatorios/relatorios-disponiveis", {
          params: {
            tipo: context.state.tipoSelecionado,
          },
        })
        .then((res) => {
          if (res.data.success) {
            context.commit("setRelatorios", res.data.data);
          }
        });
    },
  },
  getters: {},
};

export default relatoriosStore;
